<template>
  <card :class="['browse-code', 'mr-3']">
    <card-title v-html="$lang.browseCode" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
    <card-actions align="left">
      <flex>
        <flex-col :span="4" sm12>
          <container :class="['pr-1']">
            <btn block tag="a" target="_blank" rel="noopener" :href="bitBucketPage" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" size="xs" :title="pageLabel">{{ pageLabel }}</btn>
          </container>
        </flex-col>
        <flex-col :span="4" sm12 v-if="bitBucketCode">
          <container :class="['pl-1']">
            <btn block tag="a" target="_blank" rel="noopener" :href="bitBucketCode" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" size="xs" :title="codeLabel">{{ codeLabel }}</btn>
          </container>
        </flex-col>
        <flex-col :span="16" equal-height sm24 />
      </flex>
    </card-actions>
  </card>
</template>
<script>
export default {
  name: 'BrowseCode',
  data () {
    return {
      bitBucketPage: null,
      bitBucketCode: null
    }
  },
  watch: {
    '$route.path' () {
      this.getBitBucketPage()
    }
  },
  computed: {
    codeLabel () {
      const bitBucketCode = this.bitBucketCode
      const lang = this.$lang
      return bitBucketCode.indexOf('directives') > -1 ? lang.directive : lang.viewComponentOnBitbucket
    },
    pageLabel () {
      return this.$lang.viewPageOnBitbucket
    }
  },
  mounted () {
    this.getBitBucketPage()
  },
  methods: {
    getBitBucketPage () {
      const repo = this.$config.repository.url
      const browseSrc = `browse/src/`
      const directives = 'directives'
      const sectionSlugs = ['ui', 'forms', 'content', 'getting-started', directives]
      const exclusionSlugs = ['getting-started', 'content', 'sitemap', 'roadmap']
      const emptySlugs = ['index', 'search', 'section']
      let slug = location.href.split('/').splice(3)
      let codeSlug
      if (slug.length === 1 && slug[0] === '') {
        slug = 'index'
      } else if (slug.length === 1 && slug[0] !== '') {
        slug = sectionSlugs.includes(slug[0]) ? 'section' : slug[0]
      } else {
        slug = slug.join('/')
      }
      slug = slug.split('?')[0]
      this.bitBucketPage = `${repo}${browseSrc}pages/${slug}.vue`
      codeSlug = slug.split('/')
      if (emptySlugs.includes(slug) || exclusionSlugs.includes(location.href.split('/').splice(3)[0])) {
        this.bitBucketCode = null
      } else {
        const deep = codeSlug[0] === directives ? `${directives}/${codeSlug[1]}.js` : `components/${codeSlug[1]}/${codeSlug[1]}.vue`
        this.bitBucketCode = `${repo}${browseSrc}bcq-ui/${deep}`
      }
    }
  }
}
</script>
<style>
.browse-code .bcq-flex:only-child
{
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/browse-code.vue